import { useLocation } from "react-router-dom"
import { useToastSeeker } from "@ui-seeker/app"
import { getExcel, postExcel } from "@ui-seeker/utils"

import { commonFiltersValue, encodeCommonFiltersShareValue } from "@signals"


export default function useToast() {
    const { showToast } = useToastSeeker()
    
    const { pathname } = useLocation();
    const filters = commonFiltersValue.peek()

    const basePromise = (myFunction, url, data, filename, config={}) => showToast.promise(myFunction(url, {
        ...data,
        downloadURL: `${window.location.host}${pathname}?sp=${encodeCommonFiltersShareValue(filters)}`
    }, filename), {
        success: 'Excel downloaded.',
        loading: 'Downloading...',
        ...config,
    })
  
    return {
        showToast: {
            ...showToast,

            promiseExcel: (url, extraData={}, filename=null, config={}) => basePromise(postExcel, url, {
                ...filters, ...extraData
            }, filename, config),
            promiseGetExcel: (url, filename=null, config={}) => basePromise(getExcel, url, filters, filename, config),
            promiseGetExcelWithoutFilters: (url, filename=null, config={}) => basePromise(getExcel, url, {}, filename, config)
        }
    }
}